import { createRetainedSubscription } from '#pplx/frontend/apps/ask/shared-helpers/createRetainedSubscription.js';
/** Shared lifecycle for Pins, Recents and expanded project snapshots. */
export function createSidebarSubscription(config) {
    return createRetainedSubscription({
        hiddenParkAfterMs: () => 5 * 60_000,
        open(signals) {
            let disposed = false;
            let close;
            const observer = {
                onSnapshot(value) {
                    if (disposed)
                        return;
                    signals.onActive();
                    config.onSnapshot(value);
                },
                onError(error) {
                    if (disposed)
                        return;
                    disposed = true;
                    config.onError?.(error);
                    signals.onTerminated();
                },
            };
            const attach = (dispose) => {
                if (disposed)
                    dispose();
                else
                    close = dispose;
            };
            try {
                const opened = config.subscribe(observer);
                if (typeof opened === 'function')
                    attach(opened);
                else
                    void opened.then(attach, observer.onError);
            }
            catch (error) {
                observer.onError(error);
            }
            return () => {
                disposed = true;
                close?.();
            };
        },
    });
}
//# sourceMappingURL=createSidebarSubscription.js.map